import React, { useState, useEffect } from "react";
const MinicartBanner = ({ headerBanner, cartTotal}) => {
    const targetTime = new Date(headerBanner.countdown_1);
    const [timeRemaining, setTimeRemaining] = useState({
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
    });
    const [currentStep, setCurrentStep] = useState(-1);
    const [isCountdownComplete, setIsCountdownComplete] = useState(false);
    useEffect(() => {
        const updateCountdown = () => {
          const currentTime = new Date();
          const timeDifference = targetTime - currentTime;
    
          if (timeDifference > 0) {
            const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
            const hours = Math.floor(
              (timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
            );
            const minutes = Math.floor(
              (timeDifference % (1000 * 60 * 60)) / (1000 * 60)
            );
            const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);
    
            setTimeRemaining({ days, hours, minutes, seconds });
          } else {
            setTimeRemaining({ days: 0, hours: 0, minutes: 0, seconds: 0 });
            setIsCountdownComplete(true)
            clearInterval(interval);
          }
        };
    
        const interval = setInterval(updateCountdown, 1000);
        return () => clearInterval(interval);
      }, [targetTime]);
    const steps = [
      { label: headerBanner?.percent_off_1, value: Number(headerBanner.spend_amt_1) * 100  },
      { label: headerBanner?.percent_off_2, value: Number(headerBanner.spend_amt_2) * 100 },
      { label: headerBanner?.percent_off_3, value: Number(headerBanner.spend_amt_3) * 100 },
    ];
    let percentage = 0;

    if (cartTotal >= steps[2].value) {
      percentage = 100;
    } else if (cartTotal >= steps[1].value) {
      percentage =
        50 +
        ((cartTotal - steps[1].value) / (steps[2].value - steps[1].value)) * 50;
    } else if (cartTotal >= steps[0].value) {
      percentage =
        ((cartTotal - steps[0].value) / (steps[1].value - steps[0].value)) * 50;
    }
  
    useEffect(() => {
      if (cartTotal >= steps[2].value) {
        setCurrentStep(2);
      } else if (cartTotal >= steps[1].value) {
        setCurrentStep(1);
      } else if (cartTotal >= steps[0].value) {
        setCurrentStep(0);
      } else {
        setCurrentStep(-1);
      }
    }, [cartTotal]);

    const lines = headerBanner?.discount_description?.split('*');//start for spliting setances
  return (
    <>
      {headerBanner.buy_more_banner && (
        <div className="minicart__banner">
          <div className="minicart__banner__contents">
            <p className="banner_title">{headerBanner.headline_1}</p>
            <div className="minicart__banner__description_box">
              <div className="banner__wrapper banner__wrapper--promo ">
              <div className="progress-label">
                {steps.map((step) => (
                  <span className="label">{step.label}</span>
                ))}
                </div>

                <div className="progress-bar_container">
                  <div className={`progress-bar`}>
                    <span
                      className="progress-line"
                      style={{ width: `${percentage}%` }}
                    ></span>
                    {steps.map((step, index) => (
                      <div
                        key={index}
                        className={`progress-step ${
                          index < currentStep ? "completed" : ""
                        } ${index === currentStep ? "in-progress" : ""}`}
                      >
                        <div className="circle">
                          {index <= currentStep && (
                            <span className="checkmark">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="10.713"
                                height="8.036"
                                viewBox="0 0 10.713 8.036"
                              >
                                <g
                                  id="check"
                                  transform="translate(-9.514 -11.635)"
                                >
                                  <path
                                    id="Path_16"
                                    d="M13.532,16.992l-2.679-2.678L9.514,15.653l4.018,4.018,6.695-6.7-1.338-1.34-5.357,5.357Z"
                                    fill="#fff"
                                  />
                                </g>
                              </svg>
                            </span>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="progress-label">
                {steps.map((step) => (
                   <span className="value">${step.value / 100}+</span>
                ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {headerBanner.birthday_sale_banner && (
        <div className="minicart__banner">
          <div className="minicart__banner__contents">
            <p className="banner_title">{headerBanner.headline_1}</p>
            <div className="minicart__banner__description_box">
              <div class="discount-label">
                Use code <span>{headerBanner.discount_code}</span> at checkout
              </div>
            </div>
            {!isCountdownComplete ? (
              <div className=" product__banner__wrapper">
                <div className="time-block">
                  <div className="time-count">{timeRemaining.days}</div>
                  <div className="time-label">days</div>
                </div>
                <div className="time-block">
                  <div className="time-count">{timeRemaining.hours}</div>
                  <div className="time-label">hours</div>
                </div>
                <div className="time-block">
                  <div className="time-count">{timeRemaining.minutes}</div>
                  <div className="time-label">mins</div>
                </div>
                <div className="time-block">
                  <div className="time-count">{timeRemaining.seconds}</div>
                  <div className="time-label">secs</div>
                </div>
              </div>
            ) : (
              <div className=" product__banner__wrapper">
                <div className="time-label">
                  {" "}
                  {headerBanner.post_countdown_message}
                </div>
              </div>
            )}
          </div>
        </div>
      )}
      {headerBanner.embroidery_sale_banner && (
        <div className="minicart__banner">
          <div className="minicart__banner__contents">
            <p className="banner_title">{headerBanner.headline_1}</p>
            <div className="minicart__banner__description_box">
            {lines?.map((line, index) => (
                  <p key={index}>{line.trim()}</p>
                ))}
              <div class="discount-label">{headerBanner.text_block}</div>
            </div>
            {!isCountdownComplete ? (
              <div className=" product__banner__wrapper">
                <div className="time-block">
                  <div className="time-count">{timeRemaining.days}</div>
                  <div className="time-label">days</div>
                </div>
                <div className="time-block">
                  <div className="time-count">{timeRemaining.hours}</div>
                  <div className="time-label">hours</div>
                </div>
                <div className="time-block">
                  <div className="time-count">{timeRemaining.minutes}</div>
                  <div className="time-label">mins</div>
                </div>
                <div className="time-block">
                  <div className="time-count">{timeRemaining.seconds}</div>
                  <div className="time-label">secs</div>
                </div>
              </div>
            ) : (
              <div className=" product__banner__wrapper">
                <div className="time-label">
                  {" "}
                  {headerBanner.post_countdown_message}
                </div>
              </div>
            )}
          </div>
        </div>
      )}
      {headerBanner.mothers_day_banner && (
        <div className="minicart__banner">
          <div className="minicart__banner__contents">
            <p className="banner_title">{headerBanner.headline_1}</p>
            <div className="minicart__banner__description_box">
              <div className="banner__wrapper">
                <div class="discount-block">
                  <div class="discount-value">
                    {headerBanner.delivery_date_1}
                  </div>
                  <div class="discount-label">
                    {headerBanner.delivery_type_1}
                  </div>
                </div>
                <div class="discount-block">
                  <div class="discount-value">
                    {headerBanner.delivery_date_2}
                  </div>
                  <div class="discount-label">
                    {headerBanner.delivery_type_2}
                  </div>
                </div>
                <div class="discount-block">
                  <div class="discount-value">
                    {headerBanner.delivery_date_3}
                  </div>
                  <div class="discount-label">
                    {headerBanner.delivery_type_3}
                  </div>
                </div>
              </div>
            </div>
            <div className=" minicart__banner__wrapper">
              {headerBanner.fineprint_1}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MinicartBanner;
